<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="userAvatar"/>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="message" v-if="showMessage">
          消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <DropdownItem name="userInfo" v-if="(!isSuperAdmin && !isGov) && showUserInfo">
          个人信息
        </DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    showUserInfo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isSuperAdmin () {
      return this.$store.state.user.isSuperAdmin
    },
    isGov () {
      return this.$store.state.user.isGov
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout () {
      this.handleLogOut().then(res => {
        if (res.data.success) {
          this.$router.push({
            name: 'index'
          })
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    message () {
      this.$router.push({
        name: 'message_page'
      })
    },
    userInfo () {
      this.$router.push({
        name: 'user_info'
      })
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message': this.message()
          break
        case 'userInfo': this.userInfo()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue